import { createGlobalStyle } from 'styled-components';

export const ThemeGlobalStyle = createGlobalStyle`
  `;
